import { whichTarget, getMessage, getRow, exceptionCheck_ADD_COMPONENT, common_splitRowFunc, getComponent, removeNullElements } from "../commons"

export default (state, indexes, type) => {
  console.log('state :', state);
  console.log('indexes :', indexes);
  console.log('type :', type);
  let { currentEditMessage, currentEditSlidePage } = state
  const { message_index, row_index, component_index, slidePageIndex, rowIndexDetail, prefix_type } = indexes
  // Slice first string bar(_)
  const bar_sliced_type = type.slice(1)
  // console.log('message_index :', message_index);
  // console.log('row_index :', row_index);
  // console.log('component_index :', component_index);
  const target = whichTarget(message_index, row_index, component_index)

  const editTargetFlag = (slidePageIndex || slidePageIndex === 0) && (rowIndexDetail || rowIndexDetail === 0) && (currentEditSlidePage || rowIndexDetail === 0) 
  const editState = editTargetFlag ? 'SLIDE_PAGE' : 'MESSAGE'

  // Applies only to "ROW", "COMPONENT" cases
  // Target to update message
  let updateTarget = editTargetFlag ? [currentEditSlidePage] : currentEditMessage
  let updateTargetResult = null
  // Calculated use index
  const calc_message_index = editTargetFlag ? 0 : message_index
  const calc_row_index = editTargetFlag ? rowIndexDetail : row_index

  switch(target) {
    case "MESSAGE":
      // 초기 메시지 추가일 경우
      if (!currentEditMessage) {
        return {
          editState: editState,
          result: [getMessage(prefix_type, type)],
        }  
      }

      // 메시지의 마지막에 추가되었는지 검사
      if (message_index+1 > currentEditMessage.length) {
        currentEditMessage = currentEditMessage.concat(getMessage(prefix_type, type))
        return {
          editState: editState,
          result: currentEditMessage,
        }
      }

      // Normal case
      const message_updated = []
      for (let message_index_temp=0 ; message_index_temp < currentEditMessage.length ; message_index_temp++) {
        if (message_index_temp === message_index) {
          message_updated.push(getMessage(prefix_type, type))
        }
        message_updated.push(currentEditMessage[message_index_temp])
      }
      return {
        editState: editState,
        result: message_updated,
      } 

    case "ROW":
      // console.log("Target: Row")
      updateTargetResult = updateTarget.map((message, i) => {
        if (calc_message_index === i) {
          let { rows } = message

          // // Row의 첫번째에 추가되었는지 검사 // 기본 Index를 0으로 바꾸고 업데이트 순서를 바꾸어 주석처리 됨
          // if (row_index === -1) {
          //   rows = [getRow(prefix_type, type)].concat(rows)
          //   return {
          //     ...message,
          //     rows: rows,
          //   }
          // }

          // console.log('calc_row_index :', calc_row_index)
          // console.log('row.length :', rows.length)
          // Row의 마지막 Index에 추가되었는지 검사
          if (calc_row_index+1 > rows.length) {
            rows = rows.concat(getRow(prefix_type, type))
            return {
              ...message,
              rows: rows
            }
          }

          // Normal case
          const rows_updated = []
          for (let row_index_temp=0 ; row_index_temp < rows.length ; row_index_temp++) {
            // console.log(row_index_temp, '===', calc_row_index)
            if (row_index_temp === calc_row_index) {
              rows_updated.push(getRow(prefix_type, type))
            }
            rows_updated.push(rows[row_index_temp])
          }
          // console.log('result :', {
          //   ...message,
          //   rows: rows_updated
          // });
          return {
            ...message,
            rows: rows_updated
          }
        }
        return {...message}
      })
      // Update currentEditSlidePage when flag is true
      if (editTargetFlag) {
        return {
          editState: editState,
          result: updateTargetResult[0],
        } 
      }
      return {
        editState: editState,
        result: updateTargetResult,
      } 

    case "COMPONENT":
      // console.log("Target: Component")
      updateTargetResult = updateTarget.map((message, i) => {
        if (calc_message_index === i) {
          let { rows } = message
          // Row splitting 관련 변수 
          // TODO 최적화 필요
          let row_split_new_row = null // Row has inserted component (between rows)
          let row_split_splitted_row = null // Row has splitted components
          rows = rows.map((row, i) => {
            if (calc_row_index-1 === i) {
              let { components } = row
              // Inspect code splitting condition
              if (components.length > 0 && !exceptionCheck_ADD_COMPONENT(type)) {
                const { attr } = row
                // console.log(attr, " !== ", prefix_type + "/" + bar_sliced_type);
                if (attr !== prefix_type + "/" + bar_sliced_type) {
                  // console.log("Run Row splitting")
                  const splittedResult = common_splitRowFunc(row, component_index, prefix_type, type)
                  const { firstSplittedRow, newRow, splittedRow } = splittedResult
                  row_split_new_row = newRow
                  row_split_splitted_row = splittedRow
                  return firstSplittedRow
                }
              }
              // 컴포넌트의 마지막 인덱스에 추가되었는지 검사
              if (component_index+1 > components.length) {
                // console.log("컴포넌트 마지막 인덱스에 추가됨")
                components = components.concat(getComponent(prefix_type, type)) // parameter string 맞추어줌 ("_")
                return {
                  ...row,
                  components: components
                }
              }

              // console.log("Normal case")
              // Normal case
              const components_updated = []
              for (let comp_index=0 ; comp_index < components.length ; comp_index++) {
                if (comp_index === component_index) {
                  components_updated.push(getComponent(prefix_type, type))
                }
                components_updated.push(components[comp_index])
              }
              // console.log('components_updated :', components_updated);
              return {
                ...row,
                components: components_updated
              }
            }
            return row
          })
          /**
           * Splice splitted rows 
           * Note: splice condition으로 인해 else if 사용하게 되었음
           */
          if (row_split_new_row && row_split_splitted_row) {
            rows.splice(calc_row_index, 0, row_split_new_row, row_split_splitted_row)
          } else if (row_split_new_row && !row_split_splitted_row) {
            rows.splice(calc_row_index, 0, row_split_new_row)
          }

          rows = removeNullElements(rows)
          console.log('reuslt rows :', rows);
          return {
            ...message,
            rows: rows
          }
        }
        return {...message}
      })
      // Update currentEditSlidePage when flag is true
      if (editTargetFlag) {
        return {
          editState: editState,
          result: updateTargetResult[0],
        } 
      }
      return {
        editState: editState,
        result: updateTargetResult,
      } 

    default:
      window.alert("메시지를 업데이트 할 수 없었습니다.")

  }

  return {
    editState: editState,
    result: currentEditMessage,
  }
}